const LOAD_DATA_MASTER_PROVINCES           = 'LOAD_DATA_MASTER_PROVINCES'
const LOAD_DATA_MASTER_PROVINCES_SUCCESS   = 'LOAD_DATA_MASTER_PROVINCES_SUCCESS'
const LOAD_DATA_MASTER_PROVINCES_FAILED    = 'LOAD_DATA_MASTER_PROVINCES_FAILED'
const UNMOUNT_DATA_MASTER_PROVINCES        = 'UNMOUNT_DATA_MASTER_PROVINCES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterProvincesReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_PROVINCES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_PROVINCES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_PROVINCES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_PROVINCES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterProvincesReducer;